import { http } from '~~core';

import { PixChargeSchema } from '../schemas/pix';

type Feedback = {
  feedback: {
    message: string,
  };
};

export async function fetchPixCharge(signatureRequestKey: string, pixChargeKey: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/charges/${pixChargeKey}`);

  return PixChargeSchema.parse(data).pixCharge;
}

export async function createPixCharge(signatureRequestKey: string, signerDocumentation: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/charges`, {
    method: 'post',
    body: { signerDocumentation },
  });

  return PixChargeSchema.parse(data).pixCharge;
}

export async function sendPixFeedback(pixChargeKey: string, feedback: Feedback) {
  await http(`/pix/charges/${pixChargeKey}/feedback`, {
    method: 'post',
    body: feedback,
  });
}
